import util from '@bmp-vue/core/api/util'
import Axios from 'axios'
const controller = 'Autenticacao'

function getToken () {
  try {
    return JSON.parse(localStorage.getItem('user'))?.token
  } catch {
    return null
  }
}
const url = process.env.VUE_APP_ROOT_API + controller

export default Object.assign({}, util.GetCrud(controller, ['none']), {
  Autenticar: function (sender) {
    var dto = { Login: sender.email, Senha: sender.password }
    return util.Axios.Post(controller + '/AccessToken', dto)
  },
  AutenticarOnboarding: function (sender) {
    var dto = { Login: sender.email, Senha: sender.password }
    return util.Axios.Post(controller + '/AccessTokenOnboarding', dto)
  },
  AutenticarMagalupay: function (sender) {
    var dto = { Login: sender.email, Senha: sender.password }
    return util.Axios.Post(controller + '/AutenticarMagalupay', dto)
  },
  GetOnboardingReferenceToken: function (dto) {
    const request = { ReferenceToken: dto.referenceToken }

    const headers = { Authorization: `Bearer ${getToken()}` }
    return Axios.post(url + '/GetOnboardingReferenceToken', request, { headers }).then(util.ResponseFunctions.HandleResponseBase, util.ResponseFunctions.HandleErrorBase)
  },
  Logout: function () {
    return util.Axios.Delete(controller + '/AccessToken')
  },
  RefreshToken: function (token) {
    var dto = { RefreshToken: token }
    return util.Axios.Post(controller + '/RefreshToken', dto)
  },
  RefreshTokenOnboarding: function (token) {
    var dto = { RefreshToken: token }
    return util.Axios.Post(controller + '/RefreshTokenOnboarding', dto)
  },
  RefreshTokenRetaguardaOnboarding: function () {
    return util.Axios.Post(controller + '/RefreshRetaguardaOnboarding')
  },
  RevokeRefreshToken: function (token) {
    return util.Axios.Delete(controller + 'RefreshToken', token)
  },
  AutenticarEmpresa: function (dto) {
    return util.Axios.Post(controller + '/AutenticarEmpresa', dto)
  },
  AutenticarEmpresaOnboarding: function (dto) {
    return util.Axios.Post(controller + '/AutenticarEmpresaOnboarding', dto)
  },
  SolicitarLinkSenha: function (dto) {
    dto.Login = dto.email
    return util.Axios.Post(controller + '/SolicitarLinkSenha', dto)
  },
  EnviarEmailLinkSenhaOnboarding: function (dto) {
    return util.Axios.Post(controller + '/EnviarEmailLinkSenhaOnboarding', dto)
  },
  RecuperarSenha: function (dto) {
    return util.Axios.Post(controller + '/RecuperarSenha', dto)
  },
  RecuperarSenhaOnboarding: function (dto) {
    return util.Axios.Post(controller + '/RecuperarSenhaOnboarding', dto)
  },
  ValidaTokenSenha: function (username, token) {
    const params = { username: username, token: token }
    return util.Axios.GetParams(controller + '/ValidaTokenSenha', params)
  },
  AtivarUsuario: function (username, token) {
    const params = { username: username, token: token }
    return util.Axios.GetParams(controller + '/AtivarUsuario', params)
  },
  RefreshParametros: function (parametros) {
    const params = { parametros }
    return util.Axios.GetParams(controller + '/RefreshParametros', params)
  },
  AutenticarOnboardingSolicitacao: function (dto) {
    return util.Axios.Post(controller + '/AutenticarOnboardingSolicitacao', dto)
  }
})
